<template>
  <!-- <div> -->
    <!-- Fleet Crousel -->
    <!-- <section class="fleet-carousel"> -->
    <!-- <div class="col-md-12 col-sm-12">
        <div class="tj-heading-style">
          <h3>Our Car Fleet</h3>
        </div>

        
    </div>-->
    <div class="container carousel-custom" >
      <h1>Our Car Fleet</h1>
      <p
        style="padding-left: 200px;padding-right: 200px;"
      >{{dbObj.productInfo.fleetDescription}}</p>
      <div class="pad15">
        <img :src="fleet.imageUrl" alt style="opacity: 0.5" class="img-car" />
        <!-- <p class="lead">{{fleet.title}}</p> -->
        <p>
          <i class="fas fa-taxi"></i>
          {{fleet.carType}} |
          <i class="fas fa-user-circle"></i>
          {{fleet.seating}} Passengers
          <!-- <i class="fas fa-tachometer-alt"></i>
          {{fleet.speeding}} -->
        </p>
        <!-- <strong class="price">
          ${{fleet.price}}
          <span>/ {{fleet.per}}</span>
        </strong> -->
        <br />
        <br />
        <a class="book_btn2" @click="movetoTop">
          Book Now
          <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  <!-- </div> -->
</template>
<script>
import firebase from "firebase";
export default {
  props: {
    data: Object,
    db:Object
  },
  data() {
    return {
      fleet: false,
      dbObj: null
    };
  },
  methods: {
    movetoTop() {
      document.body.scrollTop = 200; // For Safari
      document.documentElement.scrollTop = 200; // For Chrome, Firefox, IE and Opera
    }
  },
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    if (this.data) {
      this.fleet = this.data;
      this.dbObj=this.db;
    } else {
      let that = this;
      var ref = firebase.database().ref();
      ref.on(
        "value",
        function(snapshot) {
          that.dbObj = snapshot.val();
          that.fleet = that.dbObj.fleet;
        },
        // function(error) {
        //   // console.log("Error: " + error.code);
        // }
      );
    }
  }
};
</script>
<style scoped>
.book_btn2 {
  background-color: #dd3751;
  color: white;
  text-decoration: none;
  width: 130px;
  height: 45px;
  padding: 12px;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
}
.img-car {
  padding-top: 80px;
  padding-left: 420px;
  padding-right: 420px;
  width: 100%;
}
@media (max-width: 767px) {
  .img-car {
    padding-top: 80px;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
  }
}
</style>